import {useState} from "react";
import {Record,} from "react-admin";
import {CustomList, CustomListProps} from "../../components/CustomList";
import {dateFormatter, getDefaultListProps, subtractMonth,} from "../../shared/utils";
import {ClientGroupedSimpleChargeDatagrid} from "./ClientGroupedSimpleChargeDatagrid";

const beforeDate = dateFormatter(new Date());
const afterDate = dateFormatter(subtractMonth(new Date(), 1));

export const SimpleChargesList = (
  props: Omit<CustomListProps, "children"> & { Actions: React.ElementType }
) => {
  const [activeCharge, setActiveCharge] = useState<Record>();

  const { Actions, ...rest } = props;

  var appbarMain = document.getElementById("appbar-main");

  if (appbarMain) {
    appbarMain.style.display = "none"
  }

  return (
    <CustomList
      {...getDefaultListProps(rest)}
      sort={{ field: "charge_date", order: "ASC" }}
      perPage={0}
      pagination={false}
      filterDefaultValues={{
        charge_date_before: beforeDate,
        clients: [3]
      }}
    >
      <ClientGroupedSimpleChargeDatagrid
        Actions={Actions}
        activeCharge={activeCharge}
        setActiveCharge={setActiveCharge}
      />
    </CustomList>
  );
};
